// extracted by mini-css-extract-plugin
module.exports = {"localOverrideLabel":"ControlBoardLocalOverrideLabel_localOverrideLabel__1eAb_"};